module.exports = __webpack_public_path__ + "static/media/img_0.e4afd1e0.png";